/*
 *  Custom Theme Javascript Code.
 *
 */
jQuery(document).ready(function($){

	"use strict";
	
	submenuToggle();
	offCanvasToggle();
	
	$('[data-toggle="tooltip"]').tooltip();
	
	/*
	 * Submit currency select on select change.
	 *
	 */
	$('.shopify-currency-form select').on('change', function(){
	
		$(this).parents('form').submit();
	
	});
	
	/*
	 *  Add/Remove the "stuck" class to the site header
	 *  based on current position.
	 *
	 */
	var currentPosition = $(window).scrollTop();
	if(currentPosition > 80) { $('.site-header').addClass('stuck'); }
	$(window).on('scroll', function(e){
		
		currentPosition = $(window).scrollTop();
		if(currentPosition > 80) {
			$('.site-header').addClass('stuck');
		} else {
			$('.site-header').removeClass('stuck');
		}
		
	});
	
	/*
	 *  Initiate Cycle2 Slider.
	 *  This is used for when a banner section is set to "Slide" mode.
	 *  Also used when a product grid is set to "Carousel" mode and if a service has "Mobile Carousel" enabled.
	 *
	 *  @link  http://jquery.malsup.com/cycle2/
	 *
	 */
	$('.slides').cycle();
	
	var viewport                = $(window).width();
	var visibleItems            = 5;
	var isMobileCarouselActive  = false;
	var isProductCarouselActive = false;
	
	if( viewport < 1028 ) {
		visibleItems = 3;
		$('.services-mobile-carousel').cycle({
			fx:     'scrollHorz',
			slides: '> .service-wrapper',
			swipe:  true
		});
		isMobileCarouselActive = true;
	}
	if( viewport < 768 ) { visibleItems = 2; }
	if( viewport < 480 ) { visibleItems = 1; }
	
	$('.carousel').cycle({
		fx:              'carousel',
		slides:          '> .product-column',
		timeout:         0,
		speed:           200,
		carouselVisible: visibleItems,
		carouselFluid:   true,
		allowWrap:       false,
		autoHeight:      'calc'
	});
	isProductCarouselActive = true;
	
	$(window).on('resize', function(){
	
		viewport = $(window).width();
	
		if( isProductCarouselActive ) { $('.carousel').cycle('destroy'); }
		if( isMobileCarouselActive )  { $('.services-mobile-carousel').cycle('destroy'); }
	
		if( viewport < 1028 ) {
			visibleItems = 3;
			$('.services-mobile-carousel').cycle({
				fx:     'scrollHorz',
				slides: '> .service-wrapper',
				swipe:  true
			});
			isMobileCarouselActive = true;
		}
		if( viewport < 768 ) { visibleItems = 2; }
		if( viewport < 480 ) { visibleItems = 1; }
		
		$('.carousel').cycle({
			fx:              'carousel',
			slides:          '> .product-column',
			timeout:         0,
			speed:           200,
			carouselVisible: visibleItems,
			carouselFluid:   true,
			allowWrap:       false,
			autoHeight:      'calc'
		});
		isProductCarouselActive = true;
		
	});
	
	/*
	 *  Expand/Collapse sidebar menus on mobile.
	 *
	 */
	$('.sidebar-expand').on('click', function(e){
		
		e.preventDefault();
		
		var filter_menu = $(this).next().next();
		var icon        = $(this).find('i');
		
		filter_menu.toggleClass('expanded').slideToggle(100);
		if( icon.hasClass('fa-plus') ) {
			icon.addClass('fa-minus').removeClass('fa-plus');
		} else {
			icon.addClass('fa-plus').removeClass('fa-minus');
		}
		
	});
	
	/*
	 * Toggle the visibility of account forms.
	 *
	 */
	$('.address-edit-toggle').on('click', function(e){
		
		e.preventDefault();
		$(this).parent().next().removeClass('hidden');
		
	});
	
	$('.address-edit-cancel').on('click', function(e){
		
		e.preventDefault();
		$(this).parent().parent().addClass('hidden');
		
	});
	
	$('.recover-password-toggle').on('click', function(e){
		
		e.preventDefault();
		$(this).parent().next().toggleClass('hidden');
		
	});
	
	/*
	 *  Expand/collapse rich text sections.
	 *
	 */
	$('.rich-accordion-header').on('click', function(e){
		
		e.preventDefault();
		
		$(this).parent().parent().next().toggleClass('expanded');
		$(this).find('.fa').toggleClass('fa-minus').toggleClass('fa-plus');
		
	});
	
	/*
	 *  Update the main product featured image when thumbnails are clicked.
	 *  Also uses Zoom plugin for product zoom.
	 *
	 *  @link  http://www.jacklmoore.com/zoom
	 *
	 */
	$('.product-thumbnail').on('click', function(){
		
		var new_url    = $(this).attr('data-featured');
		var master_url = $(this).attr('data-master');
		
		$('.product-featured-image').replaceWith('<img class="product-featured-image" src="' + new_url + '" alt="" data-zoom="' + master_url + '">');
		$('.product-zoom').trigger('zoom.destroy');
		if(jQuery.zoom) {
			
			$('.product-zoom').zoom({
				
				url:   master_url,
				touch: false
				
			});
			
		}
		
	});
	if(jQuery.zoom) {
	
		$('.product-zoom').zoom({
		
			url:   $('.product-featured-image-wrapper').find('img').attr('data-zoom'),
			touch: false
	
		});
	
	}
	
	/*
	 *  Add "Load More" functionality via ajax.
	 *
	 */
	var triggered = false;
	
	$('.load-more').off('click').on('click', function(e){
		
		e.preventDefault();
		
		var target = $('.load-more').attr('href');
		if(triggered == false) {
			
			triggered = true;
			$.ajax({
				
				url:     target,
				type:    'GET',
				success: function(data){
				
					var newTarget = $(data).find('.load-more').attr('href');
					if( is_collection_page || is_search_page ) {
						var filteredData = $(data).find('.product-column');
					} else {
						var filteredData = $(data).find('.blog-column');
					}
				
					if( is_collection_page || is_search_page ) {
						$('.product-loop').append(filteredData);
					} else {
						$('.blog-loop').append(filteredData);
					}
					
					$('.load-more').attr('href', newTarget);
					if( ! newTarget ) {
						$('.load-more').remove();
					}
				
					triggered = false;
					addToCart();
				
				}
				
			});
			
		}
		
	});
	
	/*
	 * Toggle the cart sidebar on/off.
	 *
	 */
	$('.cart-toggle').on('click', function(e){
		e.preventDefault();
		$('.off-canvas-cart').addClass('in');
	});
	
	$('.header-cart-contents-close, .btn-continue-shopping, .off-canvas-cart-background').on('click', function(e){
		e.preventDefault();
		$('.off-canvas-cart').removeClass('in');
	});
	
	/*
	 *  Add sorting functionality to collection pages.
	 *
	 */
	if( is_collection_page ) {
		
		/*
		 *  Sort products by default Shopify sort order
		 *
		 */
		Shopify.queryParams = {};				
		if(location.search.length) {
		
			for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
			
				aKeyValue = aCouples[i].split('=');
				
				if(aKeyValue.length > 1) {
				
					Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
				
				}
			
			}
		
		}
	
		$('#sort-by')
			.val(current_sort_by)
			.bind('change', function() {
			
				Shopify.queryParams.sort_by = jQuery(this).val();
				location.search             = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
			
		});
		
		/*
		 *  Change the number of products to view per page.
		 *
		 */
		$('#num-products').on('change', function(e){
		
			var url = $(this).val();
			window.location.href = url;
		
		});
		
	}
	
	addToCart();

});

/*
 *  Add products to the cart object via ajax.
 *  Used on collection pages.
 *
 *  @link  https://help.shopify.com/en/themes/development/getting-started/using-ajax-api
 *
 */
function addToCart(){
	
	$('.product-modals').off('click').on('click', '.modal-product-add-to-cart', function(e){
		
		e.preventDefault();
		
		var form = $(this).parent();
		
		$.ajax({
			
			type:     'POST', 
			url:      '/cart/add.js',
			dataType: 'json',
			data:     form.serialize(),
			success:  function(product){
				
				cartCount ++;
				cartTotal += product.price;
				
				var cartHTML = '' +
				
					'<div class="shop-icon-basket-inner">' +
						'<i class="' + cartIcon + '"></i>' +
						'<span class="cart-item-count">' + cartCount + '</span>' +
					'</div>';
				
				$('.shop-icon-basket-inner').replaceWith(cartHTML);
				
				if( has_icon_text ) {
					
					var icon_text = '<span class="icon-label icon-label-cart"><span class="money">' + Shopify.formatMoney(cartTotal) + '</span></span>';
					$('.icon-label-cart').replaceWith(icon_text);
				
				}
				
				var mobileCartHTML = '' +
				
					'<div class="mobile-cart-wrapper">' +
						'<a href="/cart" class="mobile-cart"><i class="' + cartIcon + '"></i></a>' +
						'<span class="cart-item-count">' + cartCount + '</span>' +
					'</div>';
				
				$('.mobile-cart-wrapper').replaceWith(mobileCartHTML);
				
				var pos                 = product.image.lastIndexOf('.');
				var product_image_small = product.image.substring(0,pos) + '_120x120_crop_center.' + product.image.substring(pos+1);
				var trimmed_title       = product.title.substring(0,20);
				var priceHTML           = '';
				var VATHTML             = '';
				
				if( displayVAT ) {
					
					var priceWithoutVAT = cartTotal;
					var priceWithVAT    = cartTotal * VATValue;
					
					priceHTML += '<span class="without-vat">' + Shopify.formatMoney(priceWithoutVAT) + '<span class="vat-text"> ' + VATTextWithout + '</span></span>';
					priceHTML += '<span class="with-vat">' + Shopify.formatMoney(priceWithVAT) + '<span class="vat-text"> ' + VATTextWith + '</span></span>';
					
					VATHTML = '<span class="vat-text">' + VATTextWithout + '</span>';
					
				} else {
					
					priceHTML += Shopify.formatMoney(cartTotal);
					
				}
				
				var itemHTML = '' +
				
					'<div class="header-cart-contents-item d-flex">' +
						'<div class="header-cart-contents-product-image">' +
							'<a href="' + product.url + '">' +
								'<img src="' + product_image_small + '" alt="' + product.title + '">' +
							'</a>' +
						'</div>' +
						'<div class="header-cart-contents-product-details d-flex flex-column justify-content-center text-left">' +
							'<span class="header-cart-contents-product-quantity">' + theme.strings.qty + ' 1</span>' +
							'<h6 class="header-cart-contents-product-title">' +
								'<strong><a href="' + product.url + '">' + trimmed_title + '&hellip;</a></strong>' +
							'</h6>' +
							'<span class="header-cart-contents-product-price">' + Shopify.formatMoney(product.price) + VATHTML + '</span>' +
						'</div>' +
					'</div>';
				
				$(itemHTML).prependTo('.header-cart-loop');
				
				if(cartCount == 1) {
					$('.no-items').remove();
				}
				
				$('.header-cart-contents-total-value').html(priceHTML);
				$('.modal-product').modal('hide');
				$('.modal-product').on('hidden.bs.modal', function(e){
					$('.off-canvas-cart').addClass('in');
				});
				
			},
			error: function(error){
				console.log(error.responseText);
			}
		
		});
		
	});

}


/*
 *  Dynamic search bar functionality.
 *
 *  Adds the ability for users to view porducts as they're typing search terms.
 *
 */
$(function() {
	
	var currentAjaxRequest = null;
	var searchForms        = $('form[action="/search"]').each(function() {
	
		var input = $(this).find('input[name="q"]');
		input.attr('autocomplete', 'off').bind('keyup change', function() {
			
			var term = $(this).val();
			var form = $(this).closest('form');
			
			var searchURL   = '/search?type=product&q=*' + term + '*';
			var resultsList = $('.ajax-search-results');
			
			if (term.length > 3 && term !== $(this).attr('data-old-term')) {
				
				$(this).attr('data-old-term', term);
				if (currentAjaxRequest !== null) currentAjaxRequest.abort();
				
				currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
					
					resultsList.empty();
					
					if (data.results_count === 0) {
						
						resultsList.html('<p class="ajax-no-results">' + theme.strings.nothingFound + '</p>');
						resultsList.fadeIn(200);
					
					} else {
					
						$.each(data.results, function(index, item) {
						
							var ajax_search_html = '' +
							
								'<a href="' + item.url + '" class="ajax-search-item d-flex justify-content-start align-items-center">' +
									'<img class="ajax-search-item-thumbnail" src="' + item.thumbnail + '" src="' + item.title + '">' +
									'<div class="ajax-search-content">' +
										'<h6 class="ajax-search-item-title">' + item.title + '</h6>' +
										'<span class="ajax-search-item-price">' + item.price + '</span>' +
									'</div>' +
								'</a>';
						
							resultsList.append(ajax_search_html);
							
						});
						
						resultsList.append('<a class="ajax-search-more" href="' + searchURL + '">' + theme.strings.view + ' ' + data.results_count + ' ' + theme.strings.moreItems + '</a>');
						resultsList.fadeIn(200);
						
					}
					
				});
	
			}
		
		});
	
	});
	
	$('body').bind('click', function(){
		
		$('.ajax-search-results').hide();
	
	});

});

/*
 *  Dynamic quick view functionality.
 *
 *  Adds the ability for users to view product information dynamically.
 *
 */
$(function() {
	
	$('.quick-view-button').on('click', function(e){
		
		e.preventDefault();
		
		var currentButton  = $(this);
		var modalContainer = currentButton.parent().parent().next();
		var productHandle  = $(this).data('product-handle');
		
		$.getJSON('/products/' + productHandle + '.js', function(product) {
			
			var maxLength = 240;
			var excerpt   = product.description.substr(0, maxLength);
			var markup    = '';
			var variants  = product.variants;
			
			excerpt = excerpt.substr(0, Math.min(excerpt.length, excerpt.lastIndexOf(" "))) + '&hellip;'; // Trim the description without cutting off any words.
			
			markup += '<div class="modal-product modal fade" id="product-content-for-' + product.id + '" tabindex="-1" role="dialog" aria-labelledby="product-content-for-' + product.id + '" aria-hidden="true">';
			markup += '<div class="modal-dialog modal-dialog-centered modal-xl" role="document">';
			markup += '<div class="modal-content">';
			markup += '<div class="modal-body">';
			markup += '<div class="container-fluid">';
			markup += '<div class="row">';
			markup += '<div class="col-lg-6">';
			markup += '<div class="modal-product-featured-image mb-5 mb-lg-0">';
			markup += '<img src="' + product.featured_image + '" alt="' + product.title + '">';
			markup += '</div>';
			markup += '</div>';
			markup += '<div class="col-lg-6">';
			markup += '<header class="modal-product-header">';
			markup += '<h3 class="modal-product-title">' + product.title + '</h3>';
			/*
			markup += '<button type="button" class="close" data-dismiss="modal" aria-label="Close">';
			markup += '<span aria-hidden="true">&times;</span>';
			markup += '</button>';
			*/
			markup += '<p class="modal-product-meta">';
			markup += '<span class="modal-product-vendor">' + product.vendor + '</span>';
			
			if( product.available ) {
				markup += '<span class="modal-product-in-stock">' + theme.strings.available + '</span>';
			} else {
				markup += '<span class="modal-product-out-of-stock">' + theme.strings.unavailable + '</span>';
			}
			
			markup += '<p class="modal-product-price">';
			if( product.price === product.compare_at_price || product.compare_at_price === null ) {
				if( displayVAT ) {
					markup += '<span class="modal-product-price-normal">';
					markup += '<span class="without-vat">' + Shopify.formatMoney(product.price) + '<span class="vat-text"> ' + VATTextWithout + '</span></span>';
					markup += '<span class="with-vat">' + Shopify.formatMoney(product.price * VATValue ) + '<span class="vat-text"> ' + VATTextWith + '</span></span>';
					markup += '</span>';
				} else {
					markup += '<span class="modal-product-price-normal">' + Shopify.formatMoney(product.price) + '</span>';
				}
			} else {
				if( displayVAT ) {
					markup += '<span class="modal-product-price-original">' + Shopify.formatMoney(product.compare_at_price) + '</span><span class="modal-product-price-saving">' + Shopify.formatMoney(product.price) + '<span class="vat-text"> ' + VATTextWithout + '</span></span>';
				} else {
					markup += '<span class="modal-product-price-original">' + Shopify.formatMoney(product.compare_at_price) + '</span><span class="modal-product-price-saving">' + Shopify.formatMoney(product.price) + '</span>';
				}
			}
			markup += '</p>';
			markup += '</header>';
			markup += '<div class="modal-product-content">';
			markup += '<p>' + excerpt + '</p>';
			markup += '</div>';
			markup += '<footer class="modal-product-footer">';
			markup += '<form class="modal-product-add-to-cart-form" method="post" action="/cart/add">';
			markup += '<input type="hidden" name="id" value="' + variants[0].id + '">';
			markup += '<input type="submit" value="Quick Add" class="modal-product-add-to-cart btn btn-secondary">';
			markup += '<a href="' + product.url + '" class="btn btn-secondary">' + theme.strings.viewProduct + '</a>';
			markup += '</form>';
			markup += '<div class="social-share d-flex justify-content-start">';
			markup += '<span class="share-icon share"><i class="fas fa-share-alt"></i></span>';
			markup += '<ul class="social-share-icons d-flex justify-content-start">';
			markup += '<li><a href="https://twitter.com/intent/tweet?url=' + shopURL + product.url + '&text=' + product.title + '" class="share-icon twitter" target="_blank"><i class="fab fa-twitter"></i></a></li>';
			markup += '<li><a href="https://www.facebook.com/sharer.php?u=' + shopURL + product.url + '" class="share-icon facebook" target="_blank"><i class="fab fa-facebook-f"></i></a></li>';
			markup += '<li><a href="https://www.linkedin.com/shareArticle?mini=true&url=' + shopURL + product.url + '&title=' + product.title + '&summary=' + excerpt + '&source=' + shopName + '" class="share-icon linkedin" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>';
			markup += '<li><a href="http://pinterest.com/pin/create/link/?url=' + shopURL + product.url + '" class="share-icon pinterest" target="_blank"><i class="fab fa-pinterest-p"></i></a></li>';
			markup += '</ul>';
			markup += '</div>';
			markup += '</footer>';
			markup += '</div>';
			markup += '</div>';
			markup += '</div>';
			markup += '</div>';
			markup += '</div>';
			markup += '</div>';
			markup += '</div>';
			
			modal = $(modalContainer).html(markup);
			$('.product-modals').append(modal);
			$('#product-content-for-' + product.id ).modal();
			
		});
	
		addToCart();
	
	});

});

/*
 *  Toggle visibility of the off-canvas menu.
 *
 */
function offCanvasToggle(){
	
	$('.mobile-menu').on('click', function(e){
		e.preventDefault();
		$('.off-canvas').addClass('in');
	});
	
	$('.off-canvas-close').on('click', function(e){
		e.preventDefault();
		$('.off-canvas').removeClass('in');
	});
	
}

/*
 *  Toggle submenu visibility on mobile navigation.
 *
 */
function submenuToggle(){
	
	$('.mobile-submenu-toggle').on('click', function(e){
		
		e.preventDefault();
		var icon = $(this).find('i');
		
		$(this).next().slideToggle(200);
		
		if( icon.hasClass('fa-plus') ) {
			icon.removeClass('fa-plus').addClass('fa-minus');
		} else {
			icon.removeClass('fa-minus').addClass('fa-plus');
		}
		
	});

}

/*
 *  Any scripts that need to be re-invoked should use the shopify:section:load event.
 *
 */
jQuery(document).on( 'shopify:section:load', function(){
	
	submenuToggle();
	offCanvasToggle();
	jQuery('.slides').cycle();
	initCarousels();
	addToCart();
	
});

/* Filter Sidebar */

jQuery(document).ready(function(){
  if ($(window).width() < 992) {
    $('.shop-collection-sidebar').hide();
    $('.sidebar-menu').addClass('expanded').hide();
    $('.sidebar-expand').find('.far').removeClass('fa-minus').addClass('fa-plus');
    $('.col_filter_sidebar').click(function(){
      $('.shop-collection-sidebar').toggleClass('active_sidebar').slideToggle();
    });
  }
});